export default __webpack_public_path__ + "static/media/distance-ecoroll.9f416799.svg";